import { render, staticRenderFns } from "./tag-dialog.vue?vue&type=template&id=431cccfa&"
import script from "./tag-dialog.vue?vue&type=script&lang=js&"
export * from "./tag-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports